const SELECTORS = {
  currencySwitcher: ".pick_currency.mldesk",
  headerIcons: ".header__column.header__column--right",
  mobileTarget: ".close-and-currency",
  mlcurrent: ".mlcurrent",
  options: ".pick_currency .list .option",
  menuDrawer: ".menu-drawer__menu",
  defaultMobile: ".menu-drawer__menu .pick_currency.mldcustom",
  niceSelect: ".nice-select",
  currencySelect: "#currencies",
  optionClass: ".option"
};

let isMoving = false;
let moveAttempts = 0;
const MAX_ATTEMPTS = 5;

function waitForElement(selector, timeout = 10000) {
  return new Promise((resolve, reject) => {
    const element = document.querySelector(selector);
    if (element) {
      resolve(element);
      return;
    }
    const observer = new MutationObserver((mutations, obs) => {
      const element = document.querySelector(selector);
      if (element) {
        obs.disconnect();
        resolve(element);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => {
      observer.disconnect();
      reject(new Error(`Element ${selector} not found within ${timeout}ms`));
    }, timeout);
  });
}

async function initializeCurrencyFlagsWithWait() {
  try {
    await waitForElement(SELECTORS.currencySwitcher, 8000);
    await new Promise(resolve => setTimeout(resolve, 1000));
    try {
      await waitForElement(SELECTORS.mlcurrent, 3000);
      updateCurrentFlag(true);
    } catch (error) {}
    addFlagsToOptions();
    updateCurrencySwitcherClass();
    setupPeriodicFlagCheck();
  } catch (error) {}
}

function setupPeriodicFlagCheck() {
  let retryCount = 0;
  const maxRetries = 10;
  const checkInterval = setInterval(() => {
    retryCount++;
    const currentSpan = document.querySelector(SELECTORS.mlcurrent);
    if (currentSpan && !currentSpan.querySelector('.currency-flag')) {
      updateCurrentFlag(true);
    }
    const options = document.querySelectorAll(SELECTORS.options);
    const optionsWithoutFlags = Array.from(options).filter(opt => 
      !opt.querySelector('span.wrapper') && opt.getAttribute('data-value')
    );
    if (optionsWithoutFlags.length > 0) {
      addFlagsToOptions();
    }
    const allGood = currentSpan?.querySelector('.currency-flag') && optionsWithoutFlags.length === 0;
    if (allGood || retryCount >= maxRetries) {
      clearInterval(checkInterval);
    }
  }, 2000);
}

function moveCurrencySwitcher() {
  if (isMoving || moveAttempts >= MAX_ATTEMPTS) return;
  isMoving = true;
  moveAttempts++;
  const currencySwitcher = document.querySelector(SELECTORS.currencySwitcher);
  if (!currencySwitcher) {
    isMoving = false;
    setTimeout(moveCurrencySwitcher, 500);
    return;
  }
  function moveToTarget() {
    const headerIcons = document.querySelector(SELECTORS.headerIcons);
    const mobileTarget = document.querySelector(SELECTORS.mobileTarget);
    if (!headerIcons && !mobileTarget) {
      isMoving = false;
      return;
    }
    try {
      if (window.innerWidth < 990 && mobileTarget) {
        if (!mobileTarget.contains(currencySwitcher)) {
          mobileTarget.appendChild(currencySwitcher);
          currencySwitcher.classList.add("DRAWER");
        }
      } else if (headerIcons) {
        if (headerIcons.firstChild !== currencySwitcher) {
          headerIcons.insertBefore(currencySwitcher, headerIcons.firstChild);
          currencySwitcher.classList.remove("DRAWER");
        }
      }
    } catch (error) {}
    isMoving = false;
  }
  requestAnimationFrame(moveToTarget);
  setTimeout(() => {
    moveAttempts = 0;
  }, 5000);
}

function initializeMove() {
  moveAttempts = 0;
  setTimeout(() => {
    moveCurrencySwitcher();
    updateCurrencySwitcherClass();
    removeDefaultMobileCurrencySwitcher();
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        moveAttempts = 0;
        moveCurrencySwitcher();
        updateCurrencySwitcherClass();
        removeDefaultMobileCurrencySwitcher();
      }, 250);
    });
  }, 1000);
}

function updateCurrencySwitcherClass() {
  const currencySwitcher = document.querySelector(SELECTORS.currencySwitcher);
  if (!currencySwitcher) return;
  if (window.innerWidth < 990) {
    currencySwitcher.classList.add("DRAWER");
  } else {
    currencySwitcher.classList.remove("DRAWER");
  }
}

function removeDefaultMobileCurrencySwitcher() {
  const defaultMobileCurrencySwitcher = document.querySelector(SELECTORS.defaultMobile);
  if (defaultMobileCurrencySwitcher) {
    defaultMobileCurrencySwitcher.remove();
  }
}

function createFlagElement(currency, flagUrl) {
  const img = document.createElement("img");
  img.src = flagUrl;
  img.alt = `${currency} flag`;
  img.className = "currency-flag";
  return img;
}

function addFlagsToOptions() {
  const options = document.querySelectorAll(SELECTORS.options);
  if (options.length === 0) {
    return;
  }
  options.forEach((option) => {
    if (option.querySelector("span.wrapper")) return;
    const currency = option.getAttribute("data-value");
    const flagUrl = getFlagUrl(currency);
    if (flagUrl) {
      const spanWrapper = document.createElement("span");
      spanWrapper.className = "wrapper";
      spanWrapper.style.display = "flex";
      spanWrapper.style.alignItems = "center";
      const img = createFlagElement(currency, flagUrl);
      spanWrapper.appendChild(img);
      spanWrapper.appendChild(document.createTextNode(currency));
      option.textContent = "";
      option.appendChild(spanWrapper);
    }
  });
}

function updateCurrentFlag(forceUpdate = false) {
  const currentSpan = document.querySelector(SELECTORS.mlcurrent);
  if (!currentSpan) {
    return;
  }
  if (forceUpdate) {
    const existingFlag = currentSpan.querySelector(".currency-flag");
    if (existingFlag) existingFlag.remove();
  } else if (currentSpan.querySelector(".currency-flag")) {
    return;
  }
  const currency = currentSpan.textContent.trim();
  const flagUrl = getFlagUrl(currency);
  if (flagUrl && currency) {
    const text = currentSpan.textContent;
    currentSpan.textContent = "";
    const img = createFlagElement(currency, flagUrl);
    currentSpan.appendChild(img);
    currentSpan.appendChild(document.createTextNode(text));
  }
}

function getFlagUrl(currency) {
  const exceptions = {
    EUR: "eu",
    GBP: "gb",
    TRY: "tr",
  };
  const countryCode = exceptions[currency] || currency.substring(0, 2).toLowerCase();
  return countryCode ? `https://flagcdn.com/${countryCode}.svg` : "";
}

function initializeCurrencyFlags() {
  initializeCurrencyFlagsWithWait();
}

function setupObservers() {
  const mlcurrent = document.querySelector(SELECTORS.mlcurrent);
  if (mlcurrent) {
    const currencyObserver = new MutationObserver(() => {
      setTimeout(() => updateCurrentFlag(true), 100);
    });
    currencyObserver.observe(mlcurrent, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "childList" &&
        Array.from(mutation.addedNodes).some((node) =>
          node.classList?.contains("pick_currency") ||
          node.classList?.contains("localization-wrapper") ||
          node.classList?.contains("menu-drawer__localization")
        )
      ) {
        moveAttempts = 0;
        moveCurrencySwitcher();
        updateCurrencySwitcherClass();
        removeDefaultMobileCurrencySwitcher();
        setTimeout(() => {
          updateCurrentFlag(true);
          addFlagsToOptions();
        }, 100);
      }
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function setupEventListeners() {
  const currencySwitcher = document.querySelector(SELECTORS.currencySwitcher);
  if (currencySwitcher) {
    currencySwitcher.addEventListener("click", () => {
      setTimeout(() => {
        addFlagsToOptions();
        updateCurrentFlag(true);
      }, 100);
    });
  }
  const niceSelect = document.querySelector(SELECTORS.niceSelect);
  if (niceSelect) {
    niceSelect.addEventListener("click", () => {
      setTimeout(addFlagsToOptions, 100);
      setTimeout(() => updateCurrentFlag(true), 100);
    });
  }
  const currencySelect = document.getElementById(SELECTORS.currencySelect.replace("#", ""));
  if (currencySelect) {
    currencySelect.addEventListener("change", () => {
      setTimeout(() => updateCurrentFlag(true), 50);
    });
  }
  document.querySelectorAll(SELECTORS.optionClass).forEach((option) => {
    option.addEventListener("click", () => {
      setTimeout(() => updateCurrentFlag(true), 50);
    });
  });
}

function observeMenuDrawer() {
  const menuDrawer = document.querySelector(SELECTORS.menuDrawer);
  if (menuDrawer) {
    const drawerObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (
              node.nodeType === Node.ELEMENT_NODE &&
              node.matches(".pick_currency.mldcustom")
            ) {
              node.remove();
            }
          });
        }
      });
    });
    drawerObserver.observe(menuDrawer, { childList: true, subtree: true });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    initializeCurrencyFlags();
    setupObservers();
    setupEventListeners();
    observeMenuDrawer();
    removeDefaultMobileCurrencySwitcher();
    initializeMove();
  }, 1000);
});
